import React, { FC } from 'react';
import { Theme, Svg } from 'styled';
import { Color } from 'styled/theme/colors';

type Props = {
  className?: string;
  color?: Color;
};

const SideNavCloseIcon: FC<Props> = ({ className = '', color = 'blue' }) => (
  <Svg
    width="15px"
    height="15px"
    viewBox="0 0 15 15"
    fill="transparent"
    className={className}
  >
    <desc>Close Icon.</desc>
    <path
      d="M1.89 14.368L0.918 13.396L6.822 7.456L0.918 1.516L1.89 0.543999L7.794 6.484L13.662 0.543999L14.634 1.516L8.73 7.456L14.634 13.396L13.662 14.368L7.794 8.464L1.89 14.368Z"
      fill={Theme.colors[color]}
    />
  </Svg>
);

export default SideNavCloseIcon;
